import React, {Component} from 'react';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import {Route, Switch, Redirect} from 'react-router-dom';
import {ToastContainer, toast} from 'react-toastify';

import MainApp from 'routes/app'
import PageLogin from 'routes/login/'

import 'react-toastify/dist/ReactToastify.css';
import 'font-awesome/css/font-awesome.css';
import '@beardeddevops/react.framework/dist/index.css';

import lightTheme from './themes/lightTheme';
import 'constants/Styles.scss';

import API from "@beardeddevops/react.api";
import APPCONFIG from "constants/Config";
import Types from 'constants/Types';
import classNames from "classnames";
import {defaultState} from 'constants/State';
import Framework from "@beardeddevops/react.framework";

export default class App extends Component {

	constructor(props) {
		super(props);

		API.URL = APPCONFIG.settings.apiURL();
		API.Version = APPCONFIG.settings.apiVersion;
		API.UrlsToSuppress = [
			'/accounts/details',
			'/accounts/check'
		];
		API.setAJAXDefaults(this, toast);

		this.state = {}
		this.state.startLoading = false;
		this.sessionCheckingInitialized = false;
	}

	async componentDidMount() {
		const {rootState} = this.props;

		// These values can be null so rootState knows to render when these state props change,
		// or optionally in addition, a callback that fires on change. rootState.set will do nothing
		// for properties that are not declared in a subscribe call in at least one component.
		// If all components using a property unsubscribe from a property's usage, rootState doesn't set state.
		// Properties defined here not declared in root state are treated as actions that can be called via
		// rootState.triggerAction - this allows child components deep in the tree to call container methods without
		// drilling the method through components between them, e.g. reloadShell (TODO). This should result
		// in the main thread spending less CPU time invoking callbacks at each component level.
		this.rootStateID = rootState.subscribe({
			name: null,
			account: null,
			getUserInformation: this.getUserInformation,
			logout: this.handleLogout
		});

		await API.loadOptions(true, APPCONFIG.settings.apiVersion);

		// Determine session state
		await this.getUserInformation(this.props.location);

		// Start loading router tree
		this.setState({startLoading: true});

		let lastLocation = this.props.history.location.pathname;
		// Initial routing is done, reload account info on route change
		this.props.history.listen(async (location) => {
			if (lastLocation !== this.props.history.location.pathname) {
				lastLocation = this.props.history.location.pathname;
				await this.getUserInformation(location);
			}
		});
	}

	componentWillUnmount() {
		// Components need to unsubscribe from state events when unmounting, otherwise it will prevent garbage
		// collection, cause memory leaks from lingering callback references, and React will show warnings
		// about setting state in unmounted components.
		this.props.rootState.unsubscribe(this.rootStateID);
	}

	handleLogout = () => {
		this.props.rootState.set({...defaultState});
		this.props.history.push('/login');
	}

	getUserInformation = async () => {
		const {rootState} = this.props;

		let info = new API.BuildClass(Types.Admins._name, API.RequestType.READ);
		let data;

		try {
			// noinspection JSIgnoredPromiseFromCall
			data = await info.submit(null, 'GET_DETAILS');
		} catch (e) {
			console.log('getUserInformation error', e);
			return;
		}

		//If your on a locked location but logged in then redirect
		/**
		 * @object data
		 * @property server
		 * @property servers
		 * @property name_first
		 * @property name_last
		 * @property account_first
		 * @property account_last
		 * @property kiosk_location
		 */
		rootState.set({
			name: data.name_first + " " + data.name_last,
			account: data.account_first + " " + data.account_last,
			pkey: data.admin_pkey,
		});

		// Initialize services depending on an authenticated session
		await this.initSessionChecks();
	}

	handleSessionCheck = async () => {
		let lockedLocations = ['/login', '/register', '/forgot-password'];

		try {
			let check = new API.BuildClass(Types.Admins._name, API.RequestType.READ);
			await check.submit(null, 'GET_CHECK', false, false, false, true);
		} catch (e) {
			return;
		}

		//If your on a locked location but logged in then redirect
		if (lockedLocations.includes(this.props.location.pathname)) {
			if (this.props.location.pathname !== '/dashboard' ) {
				this.props.history.push('/dashboard');
				//return;
			}
		}

	}

	initSessionChecks = async () => {
		if (this.sessionCheckingInitialized) return;

		await this.handleSessionCheck();

		setInterval(async () => {
			await this.handleSessionCheck();
		}, 60000);

		this.sessionCheckingInitialized = true;
	}

	render() {
		let {startLoading} = this.state;
		let {match, location, rootState} = this.props;
		let {account} = rootState;
		let materialUITheme = lightTheme;
		let isRoot = location.pathname === '/';

		if (isRoot) {
			API.NoLoggedInNotice = false;
			return (
				<Redirect to="/dashboard"/>
			);
		}

		return (
			<MuiThemeProvider theme={createMuiTheme(materialUITheme)}>
				<div id="app-inner">
					<div className="preloaderbar hide">
						<span className="bar"/>
					</div>
					<div className='app-main full-height fixed-header sidebar-sm'>
						{account ?
							<Switch>
								<Route path={`${match.url}`} render={
									(props) => <MainApp {...props} />
								}/>
								<Redirect to="/"/>
							</Switch>
							: startLoading ?
								<Switch>
									<Route exact path="/login" component={PageLogin}/>
								</Switch>
								:
								<Framework.Elements.LoadingSpinner isLoading={true}/>
						}
						<ToastContainer autoClose={10000} style={{textAlign: "center"}}/>
					</div>
				</div>
			</MuiThemeProvider>
		);
	}
}

App = Framework.Components.withRootState(App);
